import {ShouldSkipLazyLoadFn, ShouldSkipLazyLoadType} from 'app/interface';
import {addScrollDeeplinkItemAction} from 'app/modules/scrollDeeplink/actions';
import {getHashFromLink} from 'app/utils/initialize/getHashFromLink';
import {getLoadingType} from 'app/utils/initialize/getLoadingType';
import {NON_SECTION_LINK_WITH_HASH_SELECTOR} from 'app/utils/initialize/pageLinkHashHasId';
import {parseHashUrl} from 'app/utils/urlStateElements/parseHashUrl';

export const shouldSkipLazyLoad: ShouldSkipLazyLoadFn = ({config}) => {
    const cId = config?.cId;
    if (!cId) {
        return 'LOAD_LAZY';
    }

    const loadingTypes = new Set<ShouldSkipLazyLoadType>();
    const hasReferenceToGallery = Array.from(document.querySelectorAll<HTMLAnchorElement>(NON_SECTION_LINK_WITH_HASH_SELECTOR)).some((link) => {
        const hash = getHashFromLink(link);
        return hash && getViewFromHashUrl(hash, cId);
    });

    if (hasReferenceToGallery) {
        loadingTypes.add('LOAD_EAGER');
    }

    if (addLazyScroll(cId)) {
        loadingTypes.add('LOAD_EAGER_WITH_SCROLL_TO');
    }

    return getLoadingType(loadingTypes);
};

function getViewFromHashUrl(hash: string, cid: string) {
    if (!hash) {
        return hash;
    }

    const hashState = parseHashUrl(hash);
    return Boolean(hashState[cid]);
}

export function addLazyScroll(cId: string) {
    const viewInHash = getViewFromHashUrl(window.location.hash.substring(1), cId);
    if (viewInHash) {
        addScrollDeeplinkItemAction({type: 'LAZY_SCROLL', component: 'MULTIMEDIA', cId});
        return true;
    }

    return false;
}
